// Doodle & Mai — gentle fade-up for [data-dm-reveal] elements as they scroll into view.
// The `dm-js` class (set inline in <head>) is what hides them first, so without JS they just show.
(() => {
  const showAll = () => document.querySelectorAll('[data-dm-reveal]').forEach((el) => el.classList.add('is-in'));

  if (!('IntersectionObserver' in window) || window.Shopify?.designMode) {
    showAll();
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('is-in');
        observer.unobserve(entry.target);
      }
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
  );

  const watch = () => document.querySelectorAll('[data-dm-reveal]:not(.is-in)').forEach((el) => observer.observe(el));
  watch();
  document.addEventListener('shopify:section:load', watch);
  // Printing or "find in page" shouldn't hit invisible content
  window.addEventListener('beforeprint', showAll);
})();
